import { render } from "./ConfirmationDialog.vue?vue&type=template&id=05a7aeb1&scoped=true"
import script from "./ConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialog.vue?vue&type=script&lang=js"

import "./ConfirmationDialog.vue?vue&type=style&index=0&id=05a7aeb1&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a7aeb1"]])

export default __exports__